import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg"

const SvgIconRetour = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} fill="none" viewBox="0 0 35 35" {...props}>
            <Rect width={35} height={35} fill={baseColors.green.primary} rx={7} />
            <G clipPath="url(#clip0)">
                <Path
                    fill="#fff"
                    d="M24.213 15.902l.022.005h-9.368l2.945-2.951a.766.766 0 00.223-.545.764.764 0 00-.223-.543l-.459-.458a.76.76 0 00-.54-.224.76.76 0 00-.541.223l-5.049 5.048a.758.758 0 00-.223.542c0 .207.079.4.223.544l5.048 5.048a.76.76 0 00.542.223.76.76 0 00.54-.223l.459-.459a.758.758 0 000-1.071l-2.979-2.968h9.39a.793.793 0 00.777-.785v-.649c0-.422-.365-.757-.787-.757z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h14v14H0z" transform="translate(11 10)" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgIconRetour
